import React, { memo, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Skeleton from './Skeleton';
import { useTheme } from "../themeProvider/ThemeProvider";
const SkeletonList = _ref => {
  let {
    count = 0,
    wrapperClassName,
    className,
    customEl,
    type
  } = _ref;
  const {
    theme
  } = useTheme();
  return Array(count).fill('').map((el, index) => !!customEl && /*#__PURE__*/cloneElement(customEl, {
    key: index
  }) || (wrapperClassName ? /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    key: index
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: className,
    type: type
  })) : /*#__PURE__*/React.createElement(Skeleton, {
    className: className,
    key: index,
    type: type
  })));
};
SkeletonList.propTypes = {
  count: PropTypes.number.isRequired,
  wrapperClassName: PropTypes.string,
  className: PropTypes.string
};
export default /*#__PURE__*/memo(SkeletonList);